import { render } from "./ChatInputBox.vue?vue&type=template&id=b332bf4c&scoped=true"
import script from "./ChatInputBox.vue?vue&type=script&lang=js"
export * from "./ChatInputBox.vue?vue&type=script&lang=js"

import "./ChatInputBox.vue?vue&type=style&index=0&id=b332bf4c&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b332bf4c"]])

export default __exports__